module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_1-9d7c63f4ea8e7d160db53644e68d72a3.svg";